import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseRegulatorySectionComponent } from '../../../common/base-regulatory-section/base-regulatory-section.component';
import { Document } from 'src/app/jurisdiction/jurisdiction.domain';
import { RegistrationOfEnergyProducerApplicationDocumentTypes } from 'src/app/+regep/entities/enums/regepDocumentTypes';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
  selector: 'app-energy-producers-authorization',
  templateUrl: './energy-producers-authorization.component.html',
  styleUrls: ['./energy-producers-authorization.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class EnergyProducersAuthorizationComponent extends BaseRegulatorySectionComponent {
  @Input() energySource: string;
  @Output() changeCommentText = new EventEmitter<string>();

  public readonly regepApplicationDocumentTypes = RegistrationOfEnergyProducerApplicationDocumentTypes;

  public bafaNoticeGrantChange(isBafaNoticeGranted: boolean) {
    if (isBafaNoticeGranted) {
      this.regulatoryData.bafa_auth_notice_document = new Document(
        RegistrationOfEnergyProducerApplicationDocumentTypes.BafaNoticeOfAuthorization
      );
    } else {
      this.regulatoryData.bafa_auth_notice_document = null;
    }
  }

  public showSection(): boolean {
    return ['NaturalGas', 'Other'].includes(this.energySource);
  }

  protected get sectionComment(): string {
    return this.regulatoryData.regulatory_data_sections_state?.bafa_authorization_notice_comment;
  }

  protected set sectionComment(value: string) {
    this.regulatoryData.regulatory_data_sections_state.bafa_authorization_notice_comment = value;
  }

  protected get sectionLocked(): boolean {
    return this.regulatoryData.regulatory_data_sections_state?.is_bafa_authorization_notice_locked;
  }

  protected set sectionLocked(value: boolean) {
    this.regulatoryData.regulatory_data_sections_state.is_bafa_authorization_notice_locked = value;
  }
}
